export default {
    "type": "object",
    "required": [ 'oscode', 'osdesc' ],
    "properties": {
        "oscode": {
            "type": "string",
            "default": "",
            "title": "Status Code",
            "x-cols": "2",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 2
            },
        },
        "osdesc": {
            "type": "string",
            "default": "",
            "title": "Status Description",
            "x-cols": "10",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 255
            },
        },
    }
}
